import { API_URL, API_MS_URL, API_SS_URL, API_NLP_URL } from '@/common/config';

export default {}

// Auth endpoints
export const LOGIN_URL = `${API_URL}/auth/login`
export const LOGOUT_URL = `${API_URL}/auth/logout`

// Demo endpoints
export const DEMO_URL = `${API_URL}/auth/demo/login`

// Register endpoints
export const REGISTER_URL = `${API_URL}/registration?g-recaptcha-response=:g-recaptcha-response`
export const REGISTER_CONFIRM_URL = `${API_URL}/registration/join/confirmation?g-recaptcha-response=:g-recaptcha-response`
export const FORGOT_PASSWORD_URL = `${API_URL}/registration/reset/password`
export const FORGOT_PASSWORD_CONFIRM_URL = `${API_URL}/registration/reset/password/confirmation`
export const GET_COUNTRIES_URL = `${API_URL}/registration/countries`
export const VERIFY_PHONE_NUMBER_URL = `${API_URL}/registration/verify/phone`
export const RESEND_SMS_URL = `${API_URL}/registration/verify/phone/resend`
export const ENTER_EMAIL_URL = `${API_URL}/registration/email`

// Common Payments endpoints
export const GET_RELATED_COPARENTS_URL = `${API_URL}/cases/coparents`
export const GET_CASES_URL = `${API_URL}/cases`
export const GET_COPARENTS_CHILDREN_URL = `${API_URL}/expenses/cm/mutualchildren?coparentGuid=:coparentGuid`
export const GET_PAYMENT_STATUSES_URL = `${API_URL}/expenses/paymentstatuses`
export const DELETE_EXPENSE_URL = `${API_URL}/expenses/:guid`
export const GET_ALL_EXPENSES = `${API_URL}/expenses/unpaid`
export const GET_ALL_RECURRING_EXPENSES = `${API_URL}/scheduled/expenses`
export const MARK_AS_PAID_URL = `${API_URL}/expenses/:guid`
export const GET_PAYMENTS_TYPES_URL = `${API_URL}/expenses/types`

// Pending Payments endpoints
export const PENDING_EXPENSES_LIST_URL = `${API_URL}/expenses/not-paid?page=:page&size=:size`

// Recurring Expenses
export const RECURRING_EXPENSES_LIST_URL = `${API_URL}/scheduled/expenses?page=:page&size=:size`;
export const RECURRING_EXPENSES_DETAILS_URL = `${API_URL}/scheduled/expenses/:guid`;
export const RECURRING_EXPENSES_DETAILS_TABLE_URL = `${API_URL}/scheduled/expenses/:guid/expenses?page=:page&size=:size&sort=:sort`;
export const RECURRING_EXPENSES_DETAILS_SHARED_TABLE_URL = `${API_URL}/scheduled/expenses/:guid/shared/expenses?page=:page&size=:size&sort=:sort`;
export const DELETE_SCHEDULED_EXPENSE_URL = `${API_URL}/scheduled/expenses/:guid`;
export const RECURRING_EXPENSE_FIND_BY_GUID_URL = `${API_URL}/scheduled/expenses/:guid`;
export const RECURRING_EXPENSE_SM_UPDATE_URL = `${API_URL}/expenses/sm/schedule`;
export const RECURRING_EXPENSE_CM_UPDATE_URL = `${API_URL}/expenses/cm/schedule`;
export const RECURRING_EXPENSE_SE_UPDATE_URL = `${API_URL}/expenses/se/schedule`;
export const RECURRING_EXPENSE_INTERVAL_UNITS_API = `${API_URL}/expenses/units`;

// Spousal Maintenance endpoints
export const SPOUSAL_MAINTENANCE_ADD_NEW_URL = `${API_URL}/expenses/sm/payments`
export const SPOUSAL_MAINTENANCE_EDIT_URL = `${API_URL}/expenses/sm/payments`
export const SPOUSAL_MAINTENANCE_SCHEDULED_ADD_NEW_URL = `${API_URL}/expenses/sm/schedule`
export const SPOUSAL_MAINTENANCE_FIND_BY_GUID_URL = `${API_URL}/expenses/sm/:guid`
export const SPOUSAL_MAINTENANCE_LIST_URL = `${API_URL}/expenses/sm?page=:page&size=:size`

// Child Maintenance endpoints
export const CHILD_MAINTENANCE_ADD_NEW_URL = `${API_URL}/expenses/cm/payments`
export const CHILD_MAINTENANCE_EDIT_URL = `${API_URL}/expenses/cm/payments`
export const CHILD_MAINTENANCE_SCHEDULED_ADD_NEW_URL = `${API_URL}/expenses/cm/schedule`
export const CHILD_MAINTENANCE_FIND_BY_GUID_URL = `${API_URL}/expenses/cm/:guid`
export const CHILD_MAINTENANCE_LIST_URL = `${API_URL}/expenses/cm?page=:page&size=:size`

// Shared Expenses endpoints
export const SHARED_EXPENSES_ADD_NEW_URL = `${API_URL}/expenses/se/payments`
export const SHARED_EXPENSES_EDIT_URL = `${API_URL}/expenses/se/payments`
export const SHARED_EXPENSES_SCHEDULED_ADD_NEW_URL = `${API_URL}/expenses/se/schedule`
export const SHARED_EXPENSES_FIND_BY_GUID_URL = `${API_URL}/expenses/se/:guid`
export const SHARED_EXPENSES_LIST_URL = `${API_URL}/expenses/se?page=:page&size=:size`

// Transaction history actions
export const TRANSACTION_HISTORY_LIST_URL = `${API_URL}/expenses/history?page=:page&size=:size`

// Message Center endpoints
export const GET_MESSAGE_CONTACTS_URL = `${API_URL}/cases/contacts`
export const WS = `${API_MS_URL}/ws/`
export const WS_ERRORS = `/topic/:coparentGuid/errors`
export const WS_CONVERSATIONS_SEND = `/fp/ms/:coparentGuid.conversations`
export const WS_CONVERSATIONS_SUBSCRIBE = `/topic/:coparentGuid/conversations`
export const WS_SUBSEQUENT_SEND = `/fp/ms/chat.loadSubsequentMessages.:coparentGuid.:participantGuid`
export const WS_MESSAGES_SUBSCRIBE = `/topic/:coparentGuid.:participantGuid`
export const WS_INITIAL_MESSAGES_SEND = `/fp/ms/chat.initial.:coparentGuid.:participantGuid`
export const WS_CREATE_CONVERSATION_SEND = `/fp/ms/:coparentGuid.conversations.new.:participantGuid`
export const WS_SEND_MESSAGE_SEND = `/fp/ms/chat.sendMessage.`
export const WS_CLOSE_CONVERSATION_SEND = `/fp/ms/:coparentGuid.conversations.close.:conversationGuid`
export const WS_ALL_UNREAD_SEND = `/fp/ms/chat.loadAllUnreadMessages.:coparentGuid.:participantGuid`

// Profile endpoints
export const GET_USER_PROFILE_URL = `${API_URL}/users/current`
export const GET_FAMILY_PROFILE_URL = `${API_URL}/users/family`
export const CHANGE_PASSWORD_URL = `${API_URL}/users/update`
export const EDIT_PERSONAL_INFO_URL = `${API_URL}/users/info`
export const ADD_COPARENT_URL = `${API_URL}/users/v3/coparents`
export const EDIT_COPARENT_URL = `${API_URL}/users/v3/:guid`
export const INVITE_COPARENT_URL = `${API_URL}/users/invitations/v2`
export const CANCEL_INVITATION_COPARENT_URL = `${API_URL}/users/invitations/:guid`
export const ADD_CHILD_URL = `${API_URL}/users/children`
export const EDIT_CHILD_URL = `${API_URL}/users/children/:guid`
export const DELETE_COPARENT_URL = `${API_URL}/users/:guid`
export const DELETE_CHILD_URL = `${API_URL}/users/children/:guid`
export const DELETE_ACCOUNT_URL = `${API_URL}/users/current`
export const VERIFY_PHONE_NUMBER_ON_PROFILE_URL = `${API_URL}/users/verify/phone`

// Payment Methods endpoints
export const GET_BANK_ACCOUNTS_URL = `${API_URL}/v2/payments/banks/accounts`
export const ADD_CUSTOMER_URL = `${API_URL}/payments/customer`
export const EDIT_CUSTOMER_URL = `${API_URL}/payments/customer`
export const RETRY_CUSTOMER_URL = `${API_URL}/payments/customer/retry`
export const UPLOAD_DOCUMENT_URL = `${API_URL}/payments/documents`
export const GET_BANK_INSTITUTIONS_URL = `${API_URL}/v2/payments/banks`
export const DELETE_CHECKBOOK_ACCOUNT_URL = `${API_URL}/v2/payments/banks/accounts/:bankId`
export const DEFAULT_CHECKBOOK_ACCOUNT_URL = `${API_URL}/v2/payments/banks/accounts/:bankId`
export const CHECKBOOK_LOGIN_TO_BANK_URL = `${API_URL}/v2/payments/banks/:institutionId/iav`
export const CHECKBOOK_ADD_BANK_ACCOUNT_URL = `${API_URL}/v2/payments/banks/accounts`
export const CHECKBOOK_ADD_MFA_ANSWER_URL = `${API_URL}/v2/payments/banks/:institutionId/iav/mfa`
export const CHECKBOOK_ADD_MD_AMOUNTS_URL = `${API_URL}/v2/payments/banks/accounts/verify`
export const GET_PLAID_LINK_TOKEN_URL = `${API_URL}/v2/payments/plaid/link/token`
export const GET_PLAID_ACCOUNT_PROCESSOR_TOKEN_URL = `${API_URL}/v2/payments/plaid/processor/token`
export const GET_BANK_ACCOUNT_WITH_PLAID_URL = `${API_URL}/v2/payments/banks/iav/plaid`

// Dashboard endpoints
export const GET_DASHBOARD_EVENTS_URL = `${API_SS_URL}/dashboard/events?page=:page&size=:size`
export const GET_DASHBOARD_EXPENSES_URL = `${API_URL}/expenses/dashboard?page=:page&size=:size`

// Discussion endpoints
export const GET_ALL_COMMENTS_URL = `${API_URL}/comments/:guid?page=:page&size=:size&sort=created,desc`
export const ADD_COMMENT_URL = `${API_URL}/comments`

// Subscription endpoints
export const GET_CLIENT_TOKEN_URL = `${API_URL}/subscriptions/client/token`
export const BRAINTREE_ADD_URL = `${API_URL}/subscriptions`
export const BRAINTREE_UPDATE_URL = `${API_URL}/subscriptions/:creditCardToken`
export const BRAINTREE_RETRY_PAYMENT_URL = `${API_URL}/subscriptions/retry/charge`
export const GET_SUBSCRIPTIONS_URL = `${API_URL}/subscriptions/details`
export const DELETE_SUBSCRIPTION_CARD_URL = `${API_URL}/subscriptions/cards/:creditCardToken`
export const CANCEL_SUBSCRIPTION_URL = `${API_URL}/subscriptions/cancel`
export const ADD_REFERRAL_CODE_URL = `${API_URL}/subscriptions/referral-codes`

// Pay Expense endpoints
export const PREVIEW_EXPENSE_URL = `${API_URL}/expenses/preview`
export const PAY_EXPENSE_URL = `${API_URL}/expenses/pay`

// Reports endpoints
export const GET_PAY_REPORTS_PDF_URL = `${API_URL}/reports/pdf`
export const GET_PAY_REPORTS_EXCEL_URL = `${API_URL}/reports/xlsx`
export const GET_MSG_REPORTS_PDF_URL = `${API_MS_URL}/report/pdf`
export const GET_MSG_REPORTS_EXCEL_URL = `${API_MS_URL}/report/xlsx`

// Calendar endpoints
export const ADD_EVENT_URL = `${API_SS_URL}/event/add`
export const GET_EVENTS_URL = `${API_SS_URL}/v2/calendar`
export const GET_PAYMENTS_URL = `${API_URL}/cases/payment/events`
export const GET_VISITATIONS_URL = `${API_SS_URL}/calendar/schedule/visitation`
export const GET_VISITATIONS_URL_V2 = `${API_SS_URL}/calendar/schedule/visitation/v2`
export const ADD_NEW_VISITATION_URL = `${API_SS_URL}/calendar/schedule/visitation/new`
export const DELETE_VISITATION_URL = `${API_SS_URL}/calendar/schedule/visitation/delete`
export const GET_SINGLE_EVENT_URL = `${API_SS_URL}/event/:guid`
export const DELETE_SINGLE_EVENT_URL = `${API_SS_URL}/event/:guid`
export const EDIT_SINGLE_EVENT_URL = `${API_SS_URL}/event/:guid`
export const EXPORT_CALENDAR_URL = `${API_SS_URL}/calendar/generate`
export const GET_HOLIDAYS_URL = `${API_SS_URL}/calendar/visitations/holidays`

// Notifications
export const WS_APP = `${API_URL}/ws/`
export const WS_NOTIFICATIONS_COUNT_SUBSCRIBE = `/topic/:coparentGuid/notifications/count`
export const WS_NOTIFICATIONS_COUNT_SEND = `/fp/app/:coparentGuid.notifications.count`
export const GET_NOTIFICATIONS_ALL = `${API_URL}/notifications`
export const MARK_NOTIFICATIONS_READ_ALL = `${API_URL}/notifications/markAsRead`

// NLP
export const POST_NLP_SCORE = `${API_NLP_URL}/sentiment/score`

// Preferences
export const POST_PAYMENTS_PREFERENCES_URL = `${API_URL}/preference/payment`
export const POST_PARENTING_SCHEDULE_PREFERENCES_URL = `${API_URL}/preference/parenting-schedule`
export const GET_PREFERENCES_URL = `${API_URL}/preference`

// Registration progress
export const GET_REGISTRATION_PROGRESS_URL = `${API_URL}/users/account/setup/progress`

// mislim da ova tri na dole treba da obrisem
export const GET_REGISTRATION_PROGRESS_SCHEDULE_PAYMENT_URL = `${API_URL}/users/expenses/gotit`
export const REGISTRATION_PROGRESS_GOT_IT_TOOLTIPS_URL = `${API_URL}/users/account/setup/tooltips`
